import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export interface UserState {
    /** 全局项目标题 **/
    title: string;
}

const useCommonStore = defineStore('common', () => {
    const title = ref<string>('众智社区');
    // 记录进入问题详情页前的菜单状态
    const lastMenuState = ref<{
        activeMenuItem?: string;
        activeFilter?: string;
        sortType?: 'hot' | 'recent';
        scrollPosition?: number;
    } | null>(null);

    function setTitle(val: string) {
        val && (title.value = val);
        document.title = title.value;
    }

    // 设置菜单状态
    function setLastMenuState(state: { activeMenuItem?: string; activeFilter?: string; sortType?: 'hot' | 'recent'; scrollPosition?: number } | null) {
        lastMenuState.value = state;
    }

    // 清除菜单状态
    function clearLastMenuState() {
        lastMenuState.value = null;
    }

    return {
        title,
        setTitle,
        lastMenuState,
        setLastMenuState,
        clearLastMenuState,
    };
});

export default useCommonStore;
